import { Navigate, RouteObject } from 'react-router-dom'
import PrivacidadeLgpdLayout from '@/pages/privacidade/PrivacidadeLgpdLayout'
import SolicitacoesTitularPage from '@/pages/privacidade/SolicitacoesTitularPage'
import FilaExpurgoPage from '@/pages/privacidade/FilaExpurgoPage'
import RetencoesLegaisPage from '@/pages/privacidade/RetencoesLegaisPage'
import PoliticasRetencaoPage from '@/pages/privacidade/PoliticasRetencaoPage'
import RegistrosExpurgoPage from '@/pages/privacidade/RegistrosExpurgoPage'

/**
 * Rotas da L17 (AN-12, Visão do Consultor, Onda 5 — DEV-AB): back-office de privacidade.
 * `/privacidade` é a política pública (rota de topo), por isso o prefixo `/privacidade-lgpd`.
 * Sem `SomenteBackoffice`: o critério aqui é PAPEL (ADMIN ou DPO), não persona — a casca e
 * cada página mostram "sem permissão" para os demais, sem chamar o servidor.
 */
const rotasL17: RouteObject[] = [
  {
    path: 'privacidade-lgpd',
    element: <PrivacidadeLgpdLayout />,
    children: [
      { index: true, element: <Navigate to="solicitacoes" replace /> },
      { path: 'solicitacoes', element: <SolicitacoesTitularPage /> },
      { path: 'expurgos', element: <FilaExpurgoPage /> },
      { path: 'retencoes-legais', element: <RetencoesLegaisPage /> },
      { path: 'politicas', element: <PoliticasRetencaoPage /> },
      { path: 'registros', element: <RegistrosExpurgoPage /> },
    ],
  },
]

export default rotasL17
